/**
 * ActiveGalleryInstance — 全局活跃 GalleryInstanceStore 注册表
 *
 * 解决挂件（Pendant）组件无法通过 React Context 获取当前可见的
 * GalleryInstanceStore 的问题。
 *
 * 用法：
 * - GalleryListWrapper 在 visible 变化时调用 setActive / unsetActive
 * - 挂件组件通过 activeGalleryInstance.get() 获取当前活跃实例
 * - observer() 包裹的组件会自动响应活跃实例切换
 */
import { observable, action } from 'mobx';
import GalleryInstanceStore from './GalleryInstanceStore';

const activeGalleryInstance = observable.box<GalleryInstanceStore | null>(null, {
  deep: false,
});

export const setActiveGalleryInstance = action(function setActiveGalleryInstance(
  store: GalleryInstanceStore
) {
  activeGalleryInstance.set(store);
});

export const unsetActiveGalleryInstance = action(function unsetActiveGalleryInstance(
  store: GalleryInstanceStore
) {
  if (activeGalleryInstance.get() === store) {
    activeGalleryInstance.set(null);
  }
});

export default activeGalleryInstance;
